import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWeldingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "welding-sm" }), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M92.15,57.6a.5.5,0,0,0,0-.17h0l-.06-.15,0,0a.86.86,0,0,0-.07-.1l0,0L91.8,57,67.41,42.91V37.55a.73.73,0,0,0-.36-.63L50.26,27.35a.71.71,0,0,0-.72,0L33,36.92a.73.73,0,0,0-.36.63v5.21L8.2,56.85l-.13.1,0,0a.86.86,0,0,0-.07.1l0,0-.06.15h0a.5.5,0,0,0,0,.17v4.34a.71.71,0,0,0,.36.62l41.57,24h0a.33.33,0,0,0,.12,0l0,0,.17,0,.17,0,0,0,.12,0h0L91.8,62.56a.72.72,0,0,0,.36-.62V57.6Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M92.63,57.56a1.1,1.1,0,0,0,0-.18l0-.08a1,1,0,0,0-.1-.25l0-.06a.86.86,0,0,0-.13-.17l-.07-.08a1.41,1.41,0,0,0-.21-.16L67.88,42.64V37.55a1.18,1.18,0,0,0-.59-1L50.5,26.94a1.22,1.22,0,0,0-1.21,0L32.72,36.51a1.17,1.17,0,0,0-.6,1v4.94L8,56.43a1,1,0,0,0-.26.19l-.06.07a.71.71,0,0,0-.1.14l-.06.08a1.57,1.57,0,0,0-.09.23l0,.09a1.11,1.11,0,0,0,0,.17v4.39a1.21,1.21,0,0,0,.6,1l41.55,24,.07,0a.93.93,0,0,0,.2.08l0,0a1,1,0,0,0,.3,0,.87.87,0,0,0,.31,0h.05l.19-.08L92,63a1.19,1.19,0,0,0,.61-1Zm-43.7,24.6v1.55L9.76,61.1V59.55ZM51.2,64.25V47.88l14.28-8.25V56ZM50,45.8,35.72,37.55l14.17-8.19,14.29,8.25ZM32.72,57.74l1,.54V55.15h.85V39.63L48.8,47.88V64.25l-10-5.79v2.77L49.4,67.37a1.22,1.22,0,0,0,1.2,0l16.68-9.63a1.19,1.19,0,0,0,.6-1.05V45.41L89,57.62,50.13,80.08,11,57.47,32.12,45.26V56.69A1.19,1.19,0,0,0,32.72,57.74Zm57.52,2v1.55L51.33,83.71V82.16Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M20.35,40.74a1.2,1.2,0,0,0-1.7,1.7l2.48,2.48a1.21,1.21,0,0,0,1.7,0,1.2,1.2,0,0,0,0-1.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M15.39,35.78a1.2,1.2,0,0,0-1.7,0,1.21,1.21,0,0,0,0,1.7L16.17,40a1.2,1.2,0,0,0,1.7-1.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M26.94,50.23a1.2,1.2,0,0,0,.85-2L25.31,45.7a1.2,1.2,0,0,0-1.7,1.7l2.48,2.48A1.19,1.19,0,0,0,26.94,50.23Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M10.43,30.82a1.2,1.2,0,0,0-1.7,0,1.21,1.21,0,0,0,0,1.7L11.21,35a1.2,1.2,0,0,0,1.7-1.7Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M40,59a.44.44,0,0,1-.07-.35.42.42,0,0,1,.21-.29l3.59-2a.92.92,0,0,0-.53-1.72L39,54.92a.44.44,0,0,1-.31-.13.42.42,0,0,1-.13-.32l0-4.13a.91.91,0,0,0-.26-.65,1,1,0,0,0-.67-.28.88.88,0,0,0-.83.54l-1.75,3.74a.44.44,0,0,1-.62.2l-2.43-1.43-1.8-1.8a1.2,1.2,0,0,0-1.7,1.7l2,2,1.5,2.15a.4.4,0,0,1,.07.35.47.47,0,0,1-.21.29l-3.59,2a.89.89,0,0,0-.44,1,.91.91,0,0,0,1,.69L33,60.55a.44.44,0,0,1,.44.44l0,4.13a.93.93,0,0,0,.26.66,1,1,0,0,0,.68.27.89.89,0,0,0,.82-.53L37,61.77a.45.45,0,0,1,.62-.19l3.57,2.09a.94.94,0,0,0,1.29-.38.91.91,0,0,0-.07-.95Zm-2.45.16a2.88,2.88,0,0,0-2,.62,2.62,2.62,0,0,0-.53-.75,3.05,3.05,0,0,0-1-.65,2.59,2.59,0,0,0,.41-1,2.86,2.86,0,0,0,0-1,2.82,2.82,0,0,0,2-.61,2.47,2.47,0,0,0,.54.75,2.74,2.74,0,0,0,1,.64,2.87,2.87,0,0,0-.45,2Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M29.74,57.35a1,1,0,0,0,.94-.76,1,1,0,0,0-.74-1.14l-3.25-.69a1,1,0,0,0-.72.13.94.94,0,0,0-.42.61,1,1,0,0,0,.13.72,1,1,0,0,0,.61.42l3.25.69Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M46.4,59.25a.94.94,0,0,0-.61-.42l-3.25-.69a1,1,0,0,0-1.13.74.92.92,0,0,0,.13.72,1,1,0,0,0,.6.42l3.25.69.2,0a1,1,0,0,0,.94-.76A.91.91,0,0,0,46.4,59.25Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M38.94,63.57a1,1,0,0,0-1.82.59l1,3.16a1,1,0,0,0,.92.66.92.92,0,0,0,.29,0,1,1,0,0,0,.56-.48.93.93,0,0,0,.06-.73Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M33.14,51.9a1,1,0,0,0,.91.66,1,1,0,0,0,.3,0A1,1,0,0,0,35,51.31l-1-3.16a1,1,0,0,0-1.21-.62,1,1,0,0,0-.62,1.21Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M40.36,53.91a1,1,0,0,0,.71-.32l2.22-2.47a1,1,0,0,0,.25-.69,1,1,0,0,0-.32-.66.94.94,0,0,0-1.35.07L39.64,52.3a1,1,0,0,0,.07,1.36A1,1,0,0,0,40.36,53.91Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M31.68,61.56a1,1,0,0,0-.67.32l-2.22,2.47a1,1,0,0,0-.25.69,1,1,0,0,0,.32.66,1,1,0,0,0,.64.25,1,1,0,0,0,.72-.32l2.22-2.47a.92.92,0,0,0,.24-.69.94.94,0,0,0-.31-.66A1,1,0,0,0,31.68,61.56Z"
			})
		]
	})]
});
export default SvgWeldingSm;
